import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from 'seagull';
import { Row } from 'seagull/components/Layout';
import { Typography } from 'seagull/components/Typography';
export function toastContent(message, actionLabel, biName, onAction) {
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 12,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                children: message
            }),
            /*#__PURE__*/ _jsx(Button, {
                skin: "monochrome",
                size: "small",
                bi: {
                    name: biName
                },
                onClick: onAction,
                children: actionLabel
            })
        ]
    });
}
